/**
 * @generated SignedSource<<c97933537b034922599715cf73269211>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternalUserStatusMessageUpdateDialog_internalUser$data = {
  readonly id: string;
  readonly studentProfile: {
    readonly statusMessage: string | null;
  };
  readonly " $fragmentType": "InternalUserStatusMessageUpdateDialog_internalUser";
};
export type InternalUserStatusMessageUpdateDialog_internalUser$key = {
  readonly " $data"?: InternalUserStatusMessageUpdateDialog_internalUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternalUserStatusMessageUpdateDialog_internalUser">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternalUserStatusMessageUpdateDialog_internalUser",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MATInternalStudentProfile",
      "kind": "LinkedField",
      "name": "studentProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "statusMessage",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MATInternalUser",
  "abstractKey": null
};

(node as any).hash = "f121b22516af57b79c3fdedcf7c55365";

export default node;
